(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["grabvam-demo-reviews"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('gv-review-carousel')) {
 customElements.define('gv-review-carousel', class extends HTMLElement {
  connectedCallback() {
   if(this.ready)return;
   this.ready=true;
   const track=this.querySelector('.gv-demo-review-grid');
   const cards=Array.from(track.children);
   const key='gv-review-start-v1';
   let start=0;
   try {start=Number(localStorage.getItem(key)||0)%cards.length;localStorage.setItem(key,String((start+2)%cards.length));}catch{}
   track.replaceChildren(...cards.slice(start),...cards.slice(0,start));
   const reduced=matchMedia('(prefers-reduced-motion: reduce)').matches;
   let paused=reduced,hover=false,inView=false;
   const pause=this.querySelector('[data-pause]');
   const sync=()=>{pause.textContent=paused?'Пусни':'Пауза';pause.setAttribute('aria-pressed',String(paused));};
   const move=direction=>{
    const step=track.firstElementChild.getBoundingClientRect().width+parseFloat(getComputedStyle(track).columnGap);
    const max=track.scrollWidth-track.clientWidth;
    let target=track.scrollLeft+direction*step;
    if(direction>0&&track.scrollLeft>=max-3)target=0;
    if(direction<0&&track.scrollLeft<=3)target=max;
    track.scrollTo({left:Math.max(0,Math.min(max,target)),behavior:reduced?'auto':'smooth'});
   };
   this.querySelector('[data-prev]').onclick=()=>move(-1);
   this.querySelector('[data-next]').onclick=()=>move(1);
   pause.onclick=()=>{paused=!paused;sync();};
   this.onmouseenter=()=>hover=true;
   this.onmouseleave=()=>hover=false;
   track.onkeydown=e=>{if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();move(e.key==='ArrowRight'?1:-1);}};
   this.observer=new IntersectionObserver(entries=>{inView=entries[0].isIntersecting;},{threshold:0.35});
   this.observer.observe(this);
   this.timer=setInterval(()=>{if(!paused&&!hover&&inView&&!document.hidden&&!this.contains(document.activeElement))move(1);},6000);
   sync();
  }
  disconnectedCallback(){clearInterval(this.timer);this.observer?.disconnect();this.ready=false;}
 });
}
  } catch(e) { console.error(e); }
})();

})();
